import React from "react";

const AppHeader = () => (
  <div className="header">
    <img className="App-logo" src="/images/logo.jpg" alt="logo" />
    <header className="App-header">CYF Hotel</header>
  </div>
);

export default AppHeader;
